export default __webpack_public_path__ + "static/media/fruit-2048w.08e898bf.webp";